module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_007.png
// module id = 2354
// module chunks = 5